
// src/web/components/diary-calendar-data.jsx

import React from 'react';
import _ from 'lodash'
import moment from 'moment'
import {
  List,
  ListItem,
  ListSubHeader,
} from 'react-toolbox/lib/list'
import compactListTheme from './themes/compact-list.css'

function CalendarItem(props) {
  const { item } = props
  var time

  if (item.startTime)
    time = moment(item.startTime).format('HH:mm')+'-'+
           moment(item.endTime).format('HH:mm')
  else
    time = "終日"
 
  return (
    <ListItem ripple={false} theme={compactListTheme}
      caption={`${time} ${item.title}`}
      legend={item.description} />
  )
}

export default function DiaryCalendarData(props) {
  const {
    attach_json
  } = props

  if (!attach_json)
    return null

  const {
    googleCalendars
  } = attach_json

  if (!googleCalendars)
    return null

  return (
    <div>
      {_.map(googleCalendars, (calendar, i)=>
        <List theme={compactListTheme}>
        <ListSubHeader key={i} theme={compactListTheme} caption={moment(calendar.date).format('LLLL')}/>
          {_.map(calendar.items, (item, j)=> 
            <CalendarItem key={j} item={item} />
          )}
        </List>
      )}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/web/components/diary-calendar-data.jsx